import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-customer-name-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule],
  template: `
    <div class="dialog-wrap">
      <div class="dialog-title">Nombre del cliente</div>
      <div class="dialog-content">
        <input
          class="customer-input"
          [(ngModel)]="name"
          placeholder="Ej: Juan Pérez"
          type="text"
        />
        <div class="helper">Opcional</div>
      </div>
      <div class="dialog-content" *ngIf="isAdmin">
        <div class="dialog-title small">Fecha de creación de la orden</div>
        <input
          class="customer-input"
          [(ngModel)]="createdLocal"
          type="datetime-local"
        />
        <div class="helper">Visible solo para administradores</div>
      </div>
      <div class="dialog-actions">
        <button mat-stroked-button (click)="onCancel()">Cancelar</button>
        <button mat-flat-button color="primary" (click)="onAccept()">Aceptar</button>
      </div>
    </div>
  `,
  styles: [
    `
    .dialog-wrap{padding:8px 4px}
    .dialog-title{font-size:16px;font-weight:600;margin-bottom:8px}
    .dialog-title.small{font-size:14px;font-weight:600;margin:8px 0}
    .dialog-content{margin-bottom:12px}
    .customer-input{width:100%; padding:10px 12px; border:1px solid #e2e8f0; border-radius:8px; outline:none; font-size:14px;}
    .customer-input:focus{border-color:#94a3b8; box-shadow:0 0 0 3px rgba(148,163,184,0.15)}
    .helper{font-size:12px; color:#64748b; margin-top:6px}
    .dialog-actions{display:flex; gap:8px; justify-content:flex-end}
    `
  ]
})
export class CustomerNameDialogComponent {
  name = '';
  isAdmin = false;
  createdLocal = '';

  constructor(
    private dialogRef: MatDialogRef<CustomerNameDialogComponent, { name: string; createdAt?: Date } | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: { defaultName?: string; createdAt?: string | Date; isAdmin?: boolean }
  ) {
    this.name = this.normalizeName(data?.defaultName || '');
    this.isAdmin = !!data?.isAdmin;
    const d = data?.createdAt ? new Date(data.createdAt) : new Date();
    this.createdLocal = this.toLocalInputValue(d);
  }

  onCancel() {
    this.dialogRef.close(undefined);
  }

  onAccept() {
    const val = this.normalizeName(this.name);
    const createdAt = this.isAdmin && this.createdLocal ? new Date(this.createdLocal) : undefined;
    this.dialogRef.close({ name: val, createdAt });
  }

  private toLocalInputValue(d: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    const yyyy = d.getFullYear();
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const hh = pad(d.getHours());
    const mi = pad(d.getMinutes());
    return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
  }

  private normalizeName(raw: any): string {
    if (typeof raw === 'string') return raw.trim();
    if (raw && typeof raw === 'object') {
      const candidates = [raw.name, raw.firstName, raw.lastName, raw.customerName, raw.fullName, raw.displayName];
      const found = candidates.find(v => typeof v === 'string' && v.trim().length > 0);
      return found ? found.trim() : '';
    }
    if (raw == null) return '';
    return String(raw).trim();
  }
}
